import "@aws-amplify/ui-react/styles.css";
import PhotoSelector from "../controls/PhotoSelector";
import { PhotoUpload } from "../controls/PhotoUpload";
import React from "react";
import { 
    Alert,
    AlertIcon,
    Box, 
    Center, 
    Heading,
    Stack,
    Text, 
    VStack,
} from '@chakra-ui/react'
import PageTitle from "../controls/PageTitle";

type ImageSelectorState = {
    file: File | null;
    previousResult: boolean | null;
    previousName: string | null;
    isTeamPhoto: boolean
};

class ImageSelector extends React.Component<any, ImageSelectorState> {
    constructor(props) {
        super(props);
        this.handleTeamImageSelection = this.handleTeamImageSelection.bind(this);
        this.clearFileSelection = this.clearFileSelection.bind(this);
        this.state = { file: null, previousResult: null, previousName: null, isTeamPhoto: false };
    }

    handleTeamImageSelection(file: File) {
        this.setState({ file: file, isTeamPhoto: true });
    }

    clearFileSelection(wasUploadedSuccessfully) {
        this.setState(oldState => {
            const newProps : ImageSelectorState = {
                file: null,
                previousName: oldState.file != null ? oldState.file.name : null,
                previousResult: wasUploadedSuccessfully,
                isTeamPhoto: oldState.isTeamPhoto
            };

            return newProps;
        });
    }

    render() {
        return (<>
            {this.state.file == null && (<>
                <PageTitle>Upload Photos</PageTitle>
                <Center>
                    <VStack>
                        <Text>Upload your photos for the Supporters Club Website</Text>
                        <Heading textAlign='center' mt={20} mb={10}>Team Photo Submission</Heading>
                        <Box w="50%" m={5}>
                            {this.state.previousResult === true ?
                                <Alert status='success' justifyContent='center' textAlign='center' >
                                    <AlertIcon />
                                    {this.state.previousName != null ? `${this.state.previousName} uploaded successfully!` : "Image uploaded successfully!"}
                                </Alert>
                            : null}

                            {this.state.previousResult === false ?
                                <Alert status='error' justifyContent='center'  textAlign='center'>
                                {this.state.previousName != null ? `${this.state.previousName} cancelled.` : "Image upload cancelled."}
                                </Alert>
                            : null}

                            {this.state.previousResult === null ?
                                <Box>
                                        <Center>
                                        <Stack alignContent='center' justifyContent='center'>
                                            
                                        </Stack>
                                    </Center>
                                </Box>
                            : null}
                        </Box>
                        <PhotoSelector onImageSelected={this.handleTeamImageSelection} photoDesc="Team Photo"></PhotoSelector>
                    </VStack>
                </Center>
            </>)}
            {this.state.file !== null && (<>
                <Heading textAlign='center' mt={5} mb={10}>Team Photo Submission</Heading>
                <PhotoUpload image={this.state.file} isTeamPhoto={this.state.isTeamPhoto} cancelImage={this.clearFileSelection} />
            </>)}
               
        </>)
    }
}

export default ImageSelector;